export default {
  title: 'Plano de Mídia',
  mediaChannels: 'Canais de Mídia'
}
